// @ts-strict-ignore
import {
	DiProcess,
	logTemplates,
	TemplateRegistry,
	templateService,
	utils,
} from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';
import { merge } from 'rxjs';
import {
	registerBfaaTemplate,
	registerFloorAdhesionTemplate,
	registerStickyTlbTemplate,
} from '../../shared';
import { registerRoadblockTemplate } from '../../shared/templates/roadblock-template';
import { registerUapDomElements } from './configs/register-uap-dom-elements';

@Injectable()
export class MetacriticNeutronTemplatesSetup implements DiProcess {
	constructor(private registry: TemplateRegistry) {
		templateService.setInitializer(this.registry);
	}

	execute(): void {
		const bfaa$ = registerBfaaTemplate(this.registry, registerUapDomElements);
		const floorAdhesion$ = registerFloorAdhesionTemplate(this.registry);
		const stickyTlb$ = registerStickyTlbTemplate(this.registry, registerUapDomElements);

		const isMobile = utils.client.isSmartphone() || utils.client.isTablet();
		const roadblock$ = registerRoadblockTemplate(
			this.registry,
			isMobile
				? [
						'floor_adhesion',
						'mpu-plus-top',
						'mpu-top',
						'mpu-middle',
						'mpu-bottom',
						'mobile-incontent-plus',
						'mobile-incontent-plus-bottom',
						'mobile-nav-ad-plus-banner',
						'mobile-incontent-mpu-plus',
						'mobile-incontent-all',
						'mobile-incontent-ad-plus',
					]
				: [
						'incontent-leader-plus-bottom',
						'incontent-leaderboard-bottom',
						'mpu-plus-top',
						'mpu-top',
						'mpu-middle',
						'mpu-bottom',
						'mobile-banner-plus',
						'leaderboard-middle',
						'incontent-leader-plus-top',
						'incontent-leaderboard-top',
						'incontent-all-top',
						'nav-ad-plus-leader',
						'incontent-ad-plus-billboard-middle',
						'incontent-leaderboard-middle',
						'incontent-narrow-all-top',
						'incontent-leader-plus-middle',
						'incontent_leaderboard',
						'bottom_leaderboard',
						'top_boxad',
						'incontent_boxad',
					],
		);

		logTemplates(merge(bfaa$, floorAdhesion$, roadblock$, stickyTlb$));
	}
}
